import React, { useMemo } from 'react';
import clsx from 'clsx';

interface TagProps {
  tagSize?: 'small' | 'medium' | 'large';
}

const ProductTag: React.FC<
  TagProps & React.HTMLAttributes<HTMLDivElement> & ProductTagModel
> = ({ tagSize = 'small', id, className, ...props }) => {
  const sizeClass = useMemo(() => {
    switch (tagSize) {
      case 'small':
        return 'product-tag--sm';
      case 'medium':
      default:
        return 'product-tag--md';
      case 'large':
        return 'product-tag--lg';
    }
  }, [tagSize]);

  return (
    <div
      {...props}
      className={clsx(
        className,
        'product-tag',
        sizeClass,
        id === 'expired' && 'bg-red-300 text-red-950'
      )}
    />
  );
};

export default ProductTag;
